const convert = require('color-convert');

export const getRgbaValue = (hexVal: string, opacity: number) =>
  `rgba(${convert.hex
    .rgb(hexVal.split('#')[1])
    .map((part: string) => `${part}`)}, ${opacity})`;
